import React from "react";

const STATUS_LABEL = {
    active: "En curso",
    completed: "Completado",
    upcoming: "Próximamente",
};

export default function Projects({ projects = [] }) {
    if (!projects || projects.length === 0) return null;
    return (
        <section
            id="proyectos"
            data-testid="projects-section"
            className="bg-[#F8F9FA] border-y border-[#E2E4E9]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div className="max-w-2xl">
                        <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                            Proyectos e iniciativas
                        </div>
                        <h2 className="text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                            Trabajando por un turismo mejor en Tarifa.
                        </h2>
                    </div>
                    <p className="text-[#4A5568] max-w-md">
                        Acciones colectivas para impulsar la calidad, la sostenibilidad y
                        la visibilidad del sector.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {projects.map((p, i) => (
                        <article
                            key={p.id || i}
                            data-testid={`project-card-${i}`}
                            className="bg-white border border-[#E2E4E9] hover:border-[#082050] transition-colors group flex flex-col"
                        >
                            {p.image && (
                                <div className="aspect-[16/10] overflow-hidden">
                                    <img
                                        src={p.image}
                                        alt={p.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                            )}
                            <div className="p-6 flex-1 flex flex-col">
                                <div className="text-[10px] uppercase tracking-widest text-[#082050]/60">
                                    {STATUS_LABEL[p.status] || "Proyecto"}
                                </div>
                                <h3 className="mt-2 text-xl font-semibold text-[#082050] tracking-tight">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-sm text-[#4A5568] leading-relaxed flex-1">
                                    {p.description}
                                </p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
